import React from "react";
import createReactClass from "create-react-class";

const interleave = (array, el) => {
  const newArray = [];

  array.forEach((item, i) => {
    if (array.length - 1 === i) {
      newArray.push(item);
    } else {
      newArray.push(item, el);
    }
  });

  return newArray;
}

const collapsed = [
  'Add to Calendar',
  'Details',
]

const expanded = [
  'Add to Calendar',
  'Website',
]

const EventLocationLinks = createReactClass({
  style: {
    base: {
      marginLeft: 0,
      color: "#666",
      whiteSpace: "nowrap"
    },
    link: {
      color: "#666"
    }
  },

  render() {
    const details = (
      <span key={`${this.props.id}-details`}>
        <i className="glyphicon glyphicon-info-sign" />
        &nbsp;
        <a
          style={this.style.link}
          href="##"
          onClick={this.props.onShowMore}
        >
          {this.props.phrases.details}
        </a>
      </span>
    );

    const language = this.props.event_instruction_languages.length > 0 ? (
      <span>
        <i className="glyphicon glyphicon-globe" />
        &nbsp;
        {this.props.event_instruction_languages.join(", ")}
      </span>
    ) : null;

    const website = (
      <span key={`${this.props.id}-website`}>
        <i className="glyphicon glyphicon-home" />
        &nbsp;
        <a style={this.style.link} href={this.props.url} target="_blank">
          {this.props.phrases.website}
        </a>
      </span>
    );

    const calendar = (
      <span key={`${this.props.id}-calendar`}>
        <i className="glyphicon glyphicon-calendar" />
        &nbsp;
        <a
        style={this.style.link}
        href={`https://calendar.google.com/calendar/r?cid=${encodeURIComponent(
          this.props.ics_url
        )}`}
        target="_blank"
        >
        {this.props.phrases.addToCalendar}
        </a>
      </span>
    );

    const separator = <span>&nbsp;&#183;&nbsp;</span>;

    let links;

    if (this.props.expanded) {
      links = [this.props.ics_url && calendar, website, language];
    } else {
      links = [details, this.props.ics_url && calendar, language];
    }

    const activeLinks = links.filter(link => link);

    return (
      <span style={this.style.base} className="links">
        <div>
          {interleave(activeLinks, separator)}
        </div>
      </span>
    );
  }
});

export default EventLocationLinks;
